module.exports = __webpack_public_path__ + "img/profile-woman-9-min.c7d6363e.jpg";